// extracted by mini-css-extract-plugin
module.exports = {"content":"dece2e673c--content--VcYgJ","icon-wrapper":"dece2e673c--icon-wrapper--G5Ra7","heading":"dece2e673c--heading--vl9QP","footer":"dece2e673c--footer--veeUl"};